import { createSlice } from '@reduxjs/toolkit';
import { redux } from 'Core/redux';

export const STORE_KEY = 'main';
export const INITIAL_STATE = {
  headerVisible: true,
  modals: [],
};

export const { reducer, actions } = createSlice({
  name: STORE_KEY,
  initialState: INITIAL_STATE,
  reducers: {
    setToogleHeader: (state, action) => {
      state.headerVisible = action.payload;
    },
    pushModal: (state, action) => {
      state.modals.push(action.payload);
    },
    setModalData: (state, action) => {
      const { id, data } = action.payload;
      const modal = state.modals.find(m => m.id === id);
      if (modal) {
        modal.data = data;
      }
    },
    popModal: state => {
      state.modals.pop();
    },
  },
});

export const showModal = (modalId, data = null) => {
  return (dispatch, getState) => {
    const { modals } = getState()[STORE_KEY];
    const modalExists = modals.some(modal => modal.id === modalId);

    if (!modalExists) {
      dispatch(actions.pushModal({ id: modalId, data }));
      return;
    }

    if (data != null) {
      dispatch(actions.setModalData({ id: modalId, data }));
    }
  };
};

export const closeModal = modalId => {
  return (dispatch, getState) => {
    const { modals } = getState()[STORE_KEY];
    // const newModals = modals.filter((modal) => modal.id !== modalId);
    dispatch(actions.popModal());
  };
};

redux.injectReducer(STORE_KEY, reducer);
